import React, { useEffect, useMemo, useState } from "react";
import { API } from "../../pages/backend";
import { useFlutterwave } from "flutterwave-react-v3";
import {
  Box,
  Card,
  Container,
  Grid,
  Typography,
  MenuItem,
  Popover,
  Avatar,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Select,
  InputLabel,
  TextField,
} from "@mui/material";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../reusables/layout/layout";
import InputField from "../forms/input/TextInput/InputField";
import { useDispatch, useSelector } from "react-redux";
import FormButton from "../ui/button/FormButton";
import Tab from "../tab";
import Spinner from "../ui/Spinner";
import { setTransactionDetails } from "../../store/reducers/transactionDetails";
import { toast } from "react-toastify";
import BillCard from "../paymentcard/billcard";
import TransactionCard from "../transactioncard/transactioncard";
import { MdErrorOutline } from "react-icons/md";
import { MdDone } from "react-icons/md";
import { examPrices } from "../../partials/examboardprices/examprices";
import data from "../dropDown";
import { showModal } from "../../store/reducers/modal";
import BulkPublic from "../BulkPublic";
import ResponsiveFormButton from "../ui/button/ResponsiveFormButton";
import { logOutUser } from "../../store/reducers/user";
import IndividualPublic from "../IndividualPublic";
import IndividualTrade from "../../pages/forms/individualTrade";
import BulkTrade from "../../pages/forms/BulkTrade";

const RequisitionTradeTest = ({ examName = "Trade Test", examType }) => {
  const [tab, setTab] = useState(0);
  const tabs = [
    "User Details",
    "Payment Details",
    "Transaction Details",
    // "Log Payment Dispute",
  ];
  const tradeTestPrice = examPrices?.tradeTestExamFeePerCandidate;
  const [priceInt, setPriceInt] = useState(tradeTestPrice.replace(/\D/g, ""));

  const dispatch = useDispatch();

  const [cost, setCost] = useState(0);
  const [publicServiceData, setPublicServiceData] = useState();

  const user = useSelector((state) => state.user.data.details);
  const token = useSelector((state) => state.user.data.token);
  const details = useSelector(
    (state) => state.transactionDetails.data.transactionDetails
  );
  const [amount, setAmount] = useState();
  // const charge = 0.025 * ;

  // const priceInt = price.replace(/\D/g, "");
  // const totalFee = priceInt;
  // const charge = 0.029 * totalFee;
  // const totalAmount = parseInt(charge) + parseInt(totalFee);

  // const charge = useMemo(() => {
  //   let ch = 0.015 * totalFee
  //   if (ch > 3000) return 3000;
  //   return ch
  // }, [totalFee]);

  // const totalAmount = parseInt(totalFee);

  const [payerIdData, setPayerIdData] = useState(null);
  const [payerIdError, setPayerIdError] = useState();
  const [openBulk, setOpenBulk] = useState(false);
  const [openIndividual, setOpenIndividual] = useState(false);

  console.log(token);

  console.log(details);

  // const handleTestSubTypeClick = (val) => {
  //   setTestSubType(val.target.value);
  // };
  // const handleTestSubTypeClick = (val) => {
  //   const selectedOption = optionsObj[testType].find(option => option.value === val.target.value);
  //   setTestSubType(selectedOption ? selectedOption.value : "");
  //   setTestSubType(val.target.value);
  //   console.log(selectedOption)
  // };

  const [radioValue, setRadioValue] = useState("Individual");

  const handleRadioClick = (e) => {
    if (e.target.value === "BulkPublic") {
      dispatch(showModal({ content: <BulkPublic payerID={payerId} /> }));
    } else if (e) {
      setRadioValue(radioValue === e ? " " : e);
    }
    // else {
    //   setRadioValue("Individual");
    // }
  };

  const handleCloseIndividual = () => {
    setOpenIndividual(false);
  };
  const handleCloseBulk = () => {
    setOpenBulk(false);
  };

  const handleExamType = (e) => {
    console.log(e.target.value);
    if (e.target.value === "BULK") {
      setOpenBulk(true);
    }
    if (e.target.value === "INDIVIDUAL") {
      setOpenIndividual(true);
    }
  };

  const [invoiceLoading, setInvoiceLoading] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const openAnchor = Boolean(anchorEl);

  const closeAnchor = () => {
    setAnchorEl(null);
  };

  const handleLogOut = () => {
    setAnchorEl(null);
    dispatch(logOutUser());
    navigate("/tradetest/payment/login");
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: { xs: "96%", md: "60%" },
    bgcolor: "background.paper",
    boxShadow: 24,
    //  py: 1,
    // px: 1,
    borderRadius: 5,
    overflowY: "auto",
    height: "50vh",
  };

  const navigate = useNavigate();

  // payer ID verification
  const [payerId, setPayerId] = useState("");
  const [tradeType, setTradeType] = useState("");
  const [mda, setMda] = useState("");
  const [department, setDepartment] = useState("");
  const [occupation, setOccupation] = useState("");
  const [oracleNumber, setOracleNumber] = useState("");

  const { stages } = data;
  const [stage, setStage] = useState("");

  console.log(stages);
  const [loading, setLoading] = useState(false);
  const billUrl = `${API}/bills/05?parameter=${details?.payerId}`;
  const [isReadOnly, setIsReadOnly] = useState(false); // State to track if the input should be read-only

  // Set `payerId` and read-only status based on `schoolDetails.payerId`
  useEffect(() => {
    if (user?.payerId) {
      setPayerId(user?.payerId);
      setIsReadOnly(true); // Make input read-only if `schoolDetails.payerId` is available
    } else {
      setIsReadOnly(false); // Allow input to be editable if no `schoolDetails.payerId`
    }
  }, [user]);

  // const handleInvoiceClick = async (e) => {
  //   setInvoiceLoading(true);
  //   if (!user?.payerId && !payerIdData) {
  //     toast.error(
  //       "Please verify your Payer ID before selecting Individual Payment"
  //     );
  //     return;
  //   }
  //   try {
  //     e.preventDefault();
  //     await generateBillNo();
  //     // console.log(transactionDetails)
  //     // console.log(examName)
  //   } catch (error) {
  //     console.log(error);
  //     toast.error(error.message);
  //   } finally {
  //     setInvoiceLoading(false);
  //   }
  // };
    const handleModalClick = (type) => {
      if (type === "Bulk") {
        if (!user?.payerId && !payerIdData) {
          toast.error(
            "Please verify your Payer ID before selecting Bulk Payment"
          );
          return;
        }
        dispatch(
          showModal({
            content: <BulkTrade payerID={user?.payerId || payerIdData} />,
          })
        );
      } else if (type === "Individual") {
        if (!user?.payerId && !payerIdData) {
          toast.error(
            "Please verify your Payer ID before selecting Individual Payment"
          );
          return;
        }
        dispatch(
          showModal({
            content: (
              <IndividualTrade
                payerID={user?.payerId || payerIdData}
                examName={examName}
              />
            ),
          })
        );
      }
    };

  const goBack = () => {
    window.history.back();
  };

  const getPublicServiceBillable = async () => {
    const examBillable_url = `${API}/cbs/public_billables`;

    try {
      const res = await axios.get(examBillable_url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res);
      setPublicServiceData(res?.data?.data);
      console.log(publicServiceData);
    } catch (error) {
      console.log(error);
    }
  };

  const updateIndividualDetails = async () => {
    const updateUrl = `${API}/individual/05`;
    // const modelUpdate = `${API}individual/01`;
    // const updateUrl = examName === "Public Service" ? publicUpdate : modelUpdate;

    try {
      const res = await axios.patch(
        updateUrl,
        { payerId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  };

  const saveGeneratedBill = async (body) => {
    try {
      const res = await axios.post(`${API}/bills/create`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res);
    } catch (error) {}
  };

  const generateBillNo = async () => {
    // const selectedOption = optionsObj[levelType].find(option => option.value === stageType);
    // console.log(selectedOption.id.toString().padStart(4, '0'));
    const body = {
      payer_id: payerId,
      customer_name: `${user?.firstName} ${user?.lastName}`,

      selected_quantities: [parseInt(1)],
      selected_items: [86351],
      selected_tariffs: [parseInt(tradeTestPrice)],
      assessmentCode: "05",
    };

    console.log(body.selected_items);
    try {
      const res = await axios.post(`${API}/cbs/create_invoice`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res)
      if (res?.status === 200) {
        console.log(res?.status);
        updateIndividualDetails();
        console.log(res?.data);
        // console.log(res?.data?.data?.responseData);

        const billdata = {
          // schoolId: '',

          billNumber: res?.data?.data?.bill_number,
          payerId: payerId,
          amountGenerated: priceInt,
          customerName: `${user.firstName} ${user.lastName}`,
          quantity: 1,
          assessmentCode: "05",
          payerInfos: [
            {
              surname: `${user.lastName}`,
              firstName: `${user.firstName}`,
              // middleName: `${user.middleName}`,
              // locationIdOrExamId: selectedOption.id.toString().padStart(4, '0'),
            },
          ],
        };
        console.log(billdata.payerInfos[0].locationIdOrExamId);
        const bill = saveGeneratedBill(billdata);
        console.log(bill);

        const userTransactionDetails = {
          payerName: `${user?.firstName} ${user?.lastName}`,
          productQuantity: 1,
          price: priceInt,
          // schoolName: "",
          unitPrice: tradeTestPrice,
          examType,
          email: user?.email,
          paymentExamType: examName,
          fullDesc: "Trade Test Examination [NGN]",
          billNumber: res?.data?.data?.bill_number,
          payerId: payerId,
          address: user?.address,
          // schoolName: user?.schoolName,
          priceWithCharge: priceInt,
        };
        dispatch(setTransactionDetails(userTransactionDetails));
        console.log(userTransactionDetails);
        console.log(details);

        // dispatch(setTransactionDetails(details.billNumber = res?.data?.data?.responseData ));
        // console.log(details)
        navigate("/invoice");
      }
      console.log(res);
    } catch (error) {
      if (error.response.status === 401 || error.response.status === 404) {
        toast.error("Session expired. Please logout and try again.");
      } else if (payerId === "") {
        toast.error("Payer ID is required");
      } else {
        toast.error("Unable to generate invoice, please try again later.");
      }
    }
  };

  const occupationDropDown = {
    "Artisans/Self-Employed": [
      { id: "0016", value: "Others" },
      { id: "0015", value: "Carpentry" },
      { id: "0014", value: "Tailoring & Garment Making" },
      { id: "0013", value: "Electrical Installation" },
      { id: "00012", value: "Plumbing & Pipe fitting" },
      { id: "00011", value: "Painting & Decoration" },
      { id: "00010", value: "Driver & Mechanics" },
      { id: "0009", value: "Blocklaying & Concrete" },
      { id: "0008", value: "Welding & Fabrication" },
      { id: "0007", value: "Panel Beating Carpentry & Joinery " },
      { id: "0006", value: "Leather Works" },
      { id: "0005", value: "Aluminum Fabrication" },
      { id: "0004", value: "Barbing" },
      { id: "0003", value: "Photography" },
      { id: "0002", value: "Hairdressing" },
      { id: "0001", value: "Catering and Hotel Management" },
    ],
    "Civil Servant": [
      { id: "0001", value: "M.D.A" },
      { id: "0002", value: "Department" },
    ],
  };

  const handleOccupationChange = (event) => {
    const selectedOccupation = event.target.value;
    setOccupation(selectedOccupation);
    // setMda('');
    // setOracleNumber('');

    if (selectedOccupation === "Artisans/Self-Employed") {
      setTradeType("");
    }
  };

  const tradeTypeClick = (val) => {
    const selectedOption = occupationDropDown[occupation].find(
      (option) => option.value === val.target.value
    );

    if (selectedOption) {
      setTradeType(selectedOption.value);
    }
  };

  // const tradeTypeClick = (val) => {
  //   const selectedOption = occupationDropDown[occupation].find(option => option.value === val.target.value);

  //   if (selectedOption) {
  //     setTradeType(selectedOption.value);
  //     // console.log(selectedOption.id.toString().padStart(4, '0'));
  //   }
  // };
  const updatePayerId = async () => {
    try {
      await axios.patch(
        `${API}/individual/01`,
        {
          payerId: payerId,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Payer ID updated successfully!");
    } catch (error) {
      console.error("Failed to update payer ID:", error);
      toast.error("Failed to update payer ID. Please try again.");
    }
  };
  const payerIdVerification = async () => {
    try {
      const res = await axios.get(
        `${API}/cbs/customer_details?payerId=${payerId}`
      );
      console.log(res);
      if (
        res.status === 200 &&
        payerId === res?.data?.data?.customer?.[0]?.PAYER_ID
      ) {
        setPayerIdError(null);
        console.log(res?.data?.data?.customer?.[0]?.CUSTOMER_NAME);
        setPayerIdData(res?.data?.data?.customer?.[0]);
        toast.success(
          `Payer ID verified successfully, Customer Name: ${res?.data?.data?.customer?.[0]?.CUSTOMER_NAME}`,
          {
            autoClose: 10000,
          }
        );
        await updatePayerId();
      }
    } catch (error) {
      if (error?.response && error?.response?.status === 404) {
        setPayerIdData(null);
        setPayerIdError(error?.response?.data?.message);
        toast.error(error?.response?.data?.message);
      }
      console.log(error);
    }
  };

  // useEffect(() => {
  //   if (optionsObj[testType]) {
  //     setTestSubType(optionsObj[testType][0]);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [testType]);

  // useEffect(() => {
  //   if (optionsObj[levelType]) {
  //     setStageType(optionsObj[levelType][0]?.value || "");
  //   }
  // }, [levelType]);

  const ReqFormTradeTest = () => {
    return (
      <Container sx={{ mt: 5 }}>
        <Box
          marginTop={"20px"}
          // padding={"10px 10px"}

          style={{
            marginTop: "3rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding:
              window.innerWidth >= 1280
                ? "0px 30px"
                : window.innerWidth >= 414
                ? "0px 0px"
                : "0px",
          }}
        >
          <div>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <InputField
                  name="firstName"
                  label="First Name"
                  type="firstName"
                  placeholder="First Name"
                  value={user?.firstName}
                  // onChange={(e) => {
                  //     setUsername(e.target.value);
                  // }}
                  readOnly
                  style={{ height: "100%" }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InputField
                  name="lastName"
                  label="Last Name"
                  type="lastName"
                  placeholder="Last Name"
                  value={user?.lastName}
                  // onChange={(e) => {
                  //     setUsername(e.target.value);
                  // }}
                  readOnly
                  style={{ height: "100%" }}
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <InputField
                  name="Email"
                  label="Email"
                  placeholder="Email"
                  value={user?.email}
                  type="email"
                  style={{ height: "100%" }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InputField
                  name="payerId"
                  label="Payer ID"
                  placeholder="Enter Your Payer ID"
                  // value={user?.payerId}
                  type="text"
                  style={{ height: "100%" }}
                  value={payerId}
                  onChange={(e) => {
                    if (!isReadOnly) setPayerId(e.target.value);
                  }}
                  onBlur={() => !isReadOnly && payerIdVerification()}
                  readOnly={isReadOnly}
                />
                {payerIdError != null ? (
                  <span
                    style={{
                      fontSize: "14px",
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      gap: "5px",
                      color: "red",
                    }}
                  >
                    Payer ID unverified <MdErrorOutline />{" "}
                  </span>
                ) : payerIdData != null ? (
                  <span
                    style={{
                      fontSize: "14px",
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      gap: "5px",
                      color: "green",
                    }}
                  >
                    Payer ID verified <MdDone />{" "}
                  </span>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </div>

          {/* <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <InputField
                name="D.O.B"
                label="D.O.B"
                type="date"
                // placeholder="Enter Occupation"
                // value={user?.phoneNumber}
                style={{ height: "100%" }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputField
                  name="occupation"
                  label="Occupation"
                  type="occupation"
                  placeholder="Enter your Occupation"
                  value={user?.lastName}
                  // onChange={(e) => {
                  //     setUsername(e.target.value);
                  // }}
                  // readOnly
                  style={{ height: "100%" }}
                />    
            </Grid>
          </Grid> */}

          {/* <div>
            <FormControl component="fieldset">
              <FormLabel component="legend">Test Type</FormLabel>
              <RadioGroup
                aria-label="individual"
                name="radio-button"
                value={radioValue}
                value={testType}
                style={{ marginTop: "2rem" }}
              >
                <FormControlLabel
                  value="Individual"
                  control={<Radio />}
                  label="Single Payment"
                />
                <FormControlLabel
                  value="BulkPublic"
                  control={<Radio />}
                  label="Bulk Payment"
                  style={{ marginTop: "1rem" }}
                  onChange={handleRadioClick}
                />
              </RadioGroup>
            </FormControl>
          </div> */}

          <Grid
            container
            alignItems={"center"}
            alignContent={"center"}
            my={2}
            spacing={2}
          >
            <Grid item xs={6}>
              <Typography
                variant="body1"
                sx={{
                  color: "#9b9494",
                  fontSize: "1rem",
                  fontWeight: "bolder",
                }}
                mb={1}
              >
                Occupation
              </Typography>
              <TextField
                name="occupation"
                id="occupation"
                value={occupation}
                // onChange={occupationClick}
                // onChange={(e) => {setOccupation(e.target.value)}}
                onChange={handleOccupationChange}
                label="Select occupation"
                labelId="occupation"
                style={{ width: "100%" }}
                select
              >
                {Object.keys(occupationDropDown).map((dropDown, index) => (
                  <MenuItem key={index} value={dropDown}>
                    {dropDown}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={6}>
              {occupation === "Civil Servant" ? (
                <>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#9b9494",
                      fontSize: "1rem",
                      fontWeight: "bolder",
                    }}
                    mb={1}
                  >
                    M.D.A
                  </Typography>
                  <TextField
                    label="M.D.A"
                    name="mda"
                    type="text"
                    value={mda}
                    onChange={(e) => {
                      setMda(e.target.value);
                    }}
                    style={{ height: "100%", width: "100%" }}
                  />
                </>
              ) : (
                <>
                  <Grid item xs={12}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#9b9494",
                        fontSize: "1rem",
                        fontWeight: "bolder",
                      }}
                      mb={1}
                    >
                      {tradeType === "Others" ? "Others" : "Trade Type"}
                    </Typography>{" "}
                    {tradeType === "Others" ? (
                      <InputField
                        name="Others"
                        //  label="Others"
                        placeholder="Type In Your Trade Test"
                        type="text"
                        style={{ height: "100%", width: "100%" }}
                      />
                    ) : (
                      <TextField
                        name="tradeType"
                        label="Select Trade Type"
                        select
                        id="tradeType"
                        value={tradeType}
                        onChange={tradeTypeClick}
                        // onChange={(e) => {setValue("tradeType", e.target.value); tradeTypeClick(e.target.value)}}
                        // onChange={(e) => {
                        //   const value = e.target.value
                        //   setValue = ("tradeType",value)
                        // }}
                        labelId="trade-type-label"
                        style={{ height: "100%", width: "100%" }}
                      >
                        {occupationDropDown[occupation]
                          ? occupationDropDown[occupation].map(
                              (tradeDropDown) => (
                                <MenuItem
                                  label="occupation-type"
                                  key={tradeDropDown.id}
                                  value={tradeDropDown.value}
                                >
                                  {tradeDropDown.value}
                                </MenuItem>
                              )
                            )
                          : ""}
                      </TextField>
                    )}
                  </Grid>
                </>
              )}
              <Grid></Grid>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            {occupation === "Civil Servant" && (
              <>
                <Grid item xs={6}>
                  <InputField
                    name="department"
                    label="Department"
                    type="text"
                    placeholder="Department"
                    value={department}
                    onChange={(e) => {
                      setDepartment(e.target.value.trim());
                    }}
                    style={{ height: "100%", width: "100%" }}
                  />
                </Grid>
              </>
            )}

            {occupation === "Civil Servant" && (
              <Grid item xs={6}>
                <InputField
                  name="oracleNumber"
                  label="Oracle Number"
                  type="text"
                  placeholder="Oracle Number"
                  // value={oracleNumber}
                  // onChange={(e) => {
                  //   setOracleNumber(e.target.value);
                  // }}
                  style={{ height: "100%", width: "100%" }}
                />
              </Grid>
            )}
            <Grid item xs={6}>
              <Typography
                variant="body1"
                sx={{
                  color: "#9b9494",
                  fontSize: "1rem",
                  fontWeight: "bolder",
                  marginTop: "7px",
                }}
                mb={1}
              >
                Stage
              </Typography>
              <TextField
                size="normal"
                name="stage"
                label="Select Stage"
                // type="sex"
                // placeholder="Sex"
                value={stage}
                select
                onChange={(e) => {
                  setStage(e.target.value);
                }}
                // onChange={(e) => setGender(e.target.value)}
                style={{ height: "100%", width: "100%" }}
              >
                {stages.map((gender, index) => (
                  <MenuItem key={index} value={gender.value}>
                    {gender.value}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={6}>
              <InputField
                name="test-price"
                label="Price"
                type="text"
                value={tradeTestPrice}
                style={{ height: "100%" }}
              />
            </Grid>
          </Grid>

          

          {/* <div
            style={{
              marginTop: "3rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ResponsiveFormButton
              // width="medium"
              label={
                invoiceLoading ? <Spinner width="5%" /> : " Generate Invoice"
              }
              onClick={handleInvoiceClick}
            />

            <div>
              <ResponsiveFormButton
                // width="small"
                label={"Go Back"}
                onClick={goBack}
              />
            </div>
          </div> */}
          <div
            style={{
              marginTop: "3rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ResponsiveFormButton
              width="medium"
              type="button"
              label={
                invoiceLoading ? <Spinner width="30" /> : " Single Payment"
              }
              onClick={(event) => handleModalClick("Individual", event)}
              // onClick={handleOpen}

              // onClick={handleInvoiceClick}
            />
            <div>
              <ResponsiveFormButton
                type="button"
                // width="medium"
                // label={" Go Back"} onClick={goBack}
                label="Bulk Payment"
                onClick={(event) => handleModalClick("Bulk", event)}
                // onClick={handleOpen}
              />
            </div>
          </div>
          

        </Box>
      </Container>
    );
  };

  // const PaymentForm = () => {
  //   return <BillCard url={billUrl} />;
  // };

  // const PlatformTransactionDetails = () => {
  //   return <TransactionCard />;
  // };

  // const examCard = () => {
  //   return <Examdetailspublic />;
  // };

  useEffect(() => {
    getPublicServiceBillable();
  }, []);

  useEffect(() => {
    console.log(user);
  }, [cost]);

  return (
    <div>
      {/* <Layout> */}
      <Card className="model-card" elevation={5}>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          className="bece-form-left"
          onSubmit={(e) => e.preventDefault()}
        >
          <div style={{ padding: "0px 5px" }}>
            <marquee bgcolor="white" direction="left" loop="">
              <Typography>
                <span
                  style={{
                    color: "red",
                    fontSize: "14px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  *Late Registration attracts an additional fee
                </span>
              </Typography>
            </marquee>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: "5px",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  paddingTop: "10px",
                  alignItems: "center",
                  paddingRight: "25px",
                  paddingLeft: "10px",
                }}
              >
                <Typography
                  variant="subtitle1"
                  style={{
                    // marginLeft: "10px",
                    // paddingTop: "8px",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  Welcome back
                </Typography>
                <Typography
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  {user?.firstName + " " + user?.lastName}
                </Typography>
              </div>
              <div>
                <Avatar
                  className=" lg:!flex xs:!hidden items-center"
                  size="large"
                  onClick={(e) => setAnchorEl(e.currentTarget)}
                  aria-label="account-circle"
                  style={{
                    backgroundColor: "#34A56F",
                    // lineHeight: '50px',
                    fontFamily: "Palanquin",
                    fontStyle: "normal",
                    fontWeight: 700,
                    fontSize: "20px",
                    textAlign: "center",
                    cursor: "pointer",
                    width: "35px",
                    height: "35px",
                  }}
                >
                  {user?.firstName?.charAt(0)?.toUpperCase() +
                    user?.lastName?.charAt(0)?.toUpperCase()}
                </Avatar>
                <Popover
                  open={openAnchor}
                  anchorEl={anchorEl}
                  onClose={closeAnchor}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <MenuItem onClick={handleLogOut}>Logout</MenuItem>
                </Popover>
              </div>
            </div>
          </div>
          <Typography
            variant="h5"
            align="center"
            sx={{ paddingTop: "3rem", fontWeight: "bold" }}
          >
            {examType}
          </Typography>

          <div>
            {tabs.map((x, i) => (
              <Tab
                tabs={tabs}
                key={i}
                text={x}
                active={i === tab}
                onClick={setTab}
              />
            ))}
          </div>

          {tab === 0 && ReqFormTradeTest()}
          {/* {tab === 1 && <Examdetailspublic />} */}
          {tab === 1 && <BillCard url={billUrl} examName={examName} />}
          {tab === 2 && <TransactionCard />}
          {/* {tab === 3 && <PaymentDispute type={examType} />} */}
        </Box>
        <Box compnent="div" className="model-form-right">
          <Typography
            variant="h4"
            align="center"
            sx={{ color: "#ffffff", paddingTop: "1rem", fontWeight: "bold" }}
          >
            Lagos State Exam Board
          </Typography>
          <img
            src={
              "/assets/images/laags.png"
            }
            alt="logo"
          />
          <Typography
            variant="h4"
            align="center"
            sx={{ color: "white", fontWeight: "bold", mb: 1 }}
          >
            {examName}
          </Typography>
          <Typography
            variant="body2"
            align="center"
            sx={{ color: "white", fontSize: "20px" }}
          >
            Fill the form to request for the Official Central Billing System
            Invoice ID
          </Typography>
        </Box>
      </Card>
      {/* <Modal
          open={openIndividual}
          onClose={handleCloseIndividual}
          keepMounted
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={style}>
            <IndividualPublic
              handleClose={handleCloseIndividual}
              data={user?.payerId}
            />
          </Box>
        </Modal>
        <Modal
          open={openBulk}
          onClose={handleCloseBulk}
          keepMounted
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={style} className="modal-scrollbar">
            <BulkPublic handleClose={handleCloseBulk} data={user?.payerId} />
          </Box>
        </Modal> */}
      {/* <ProceedModalPrint pin={pinNum} open={open} handleClose={handleClose} /> */}
      {/* </Layout> */}
      {/* <Footer /> */}
    </div>
  );
};

export default RequisitionTradeTest;
